import { type AlertProps, Alert as AntAlert } from 'antd'

export type UiAlertProps = AlertProps

/** Bọc mỏng: giữ NGUYÊN API AntD. Cắt prop là buộc feature phải lách. */
export const UiAlert = (props: UiAlertProps) => <AntAlert {...props} />

export default UiAlert
